export const AIChatIcon = (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_i_5329_27790)">
            <g clip-path="url(#clip0_5329_27790)">
                <rect width="40" height="40" rx="20" fill="url(#paint0_linear_5329_27790)" fill-opacity="0.88" />
                <g filter="url(#filter1_f_5329_27790)">
                    <path
                        d="M25.4973 20.834C33.728 20.834 37.8069 24.5305 37.8069 31.8496C37.8069 39.1688 33.728 42.9392 25.5701 42.9392C17.4122 42.9392 13.3333 39.2427 13.3333 31.9236C13.3333 24.6044 17.4122 20.834 25.4973 20.834Z"
                        fill="url(#paint1_linear_5329_27790)"
                    />
                </g>
                <g filter="url(#filter2_d_5329_27790)">
                    <path
                        d="M20.3215 8.94727C28.5522 8.94727 32.6312 12.6438 32.6312 19.9629C32.6312 27.2821 28.5522 31.0525 20.3943 31.0525C19.5953 31.0525 18.8355 31.0171 18.1148 30.9462C17.1747 30.8538 14.096 33.2389 13.289 33.0262C12.328 32.7729 13.6665 29.8968 12.8943 29.4734C9.73641 27.7421 8.15747 24.5906 8.15747 20.0369C8.15747 12.7177 12.2364 8.94727 20.3215 8.94727Z"
                        fill="white"
                    />
                </g>
                <path
                    d="M16.7129 16.4102C17.5022 16.4102 17.8968 16.8048 17.8968 17.594V18.7779C17.8968 19.5672 17.5022 19.9618 16.7129 19.9618C15.9237 19.9618 15.5291 19.5672 15.5291 18.7779V17.594C15.5291 16.8048 15.9237 16.4102 16.7129 16.4102Z"
                    fill="black"
                />
                <path
                    d="M23.8164 16.4102C24.6057 16.4102 25.0003 16.8048 25.0003 17.594V18.7779C25.0003 19.5672 24.6057 19.9618 23.8164 19.9618C23.0272 19.9618 22.6326 19.5672 22.6326 18.7779V17.594C22.6326 16.8048 23.0272 16.4102 23.8164 16.4102Z"
                    fill="black"
                />
                <path
                    d="M23.475 22.4982C23.5706 22.4314 23.6785 22.384 23.7924 22.3588C23.9063 22.3336 24.0241 22.3312 24.1389 22.3515C24.2538 22.3718 24.3636 22.4146 24.4619 22.4773C24.5603 22.5401 24.6453 22.6216 24.7122 22.7172C24.779 22.8128 24.8264 22.9207 24.8515 23.0346C24.8767 23.1485 24.8792 23.2663 24.8589 23.3812C24.8385 23.496 24.7958 23.6058 24.733 23.7041C24.6703 23.8025 24.5888 23.8875 24.4931 23.9544C23.2536 24.821 21.8389 25.2566 20.2762 25.2566C18.7123 25.2566 17.2976 24.821 16.058 23.9544C15.9624 23.8875 15.8809 23.8025 15.8182 23.7041C15.7554 23.6058 15.7127 23.496 15.6923 23.3812C15.672 23.2663 15.6745 23.1485 15.6996 23.0346C15.7248 22.9207 15.7722 22.8128 15.839 22.7172C15.9059 22.6216 15.9909 22.5401 16.0893 22.4773C16.1876 22.4146 16.2974 22.3718 16.4122 22.3515C16.5271 22.3312 16.6449 22.3336 16.7588 22.3588C16.8727 22.384 16.9806 22.4314 17.0762 22.4982C18.0138 23.1553 19.0722 23.4808 20.2762 23.4808C21.479 23.4808 22.5374 23.1553 23.475 22.4982Z"
                    fill="black"
                />
            </g>
        </g>
        <defs>
            <filter id="filter0_i_5329_27790" x="0" y="0" width="40" height="40" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset />
                <feGaussianBlur stdDeviation="6.66667" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                <feBlend mode="normal" in2="shape" result="effect1_innerShadow_5329_27790" />
            </filter>
            <filter
                id="filter1_f_5329_27790"
                x="-0.333414"
                y="7.16732"
                width="51.807"
                height="49.4388"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation="6.83333" result="effect1_foregroundBlur_5329_27790" />
            </filter>
            <filter
                id="filter2_d_5329_27790"
                x="-3.5092"
                y="-2.7194"
                width="47.807"
                height="47.4251"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset />
                <feGaussianBlur stdDeviation="5.83333" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5329_27790" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5329_27790" result="shape" />
            </filter>
            <linearGradient id="paint0_linear_5329_27790" x1="29.1667" y1="36.6667" x2="20" y2="1.10129e-06" gradientUnits="userSpaceOnUse">
                <stop stop-color="#8000FF" />
                <stop offset="1" stop-color="#006AFF" />
            </linearGradient>
            <linearGradient id="paint1_linear_5329_27790" x1="27.9166" y1="18.7507" x2="31.2499" y2="47.084" gradientUnits="userSpaceOnUse">
                <stop stop-color="#9500FF" />
                <stop offset="1" stop-color="#FFB700" />
            </linearGradient>
            <clipPath id="clip0_5329_27790">
                <rect width="40" height="40" rx="20" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
